/**
 * @module mapbs.components.reportpanel.egtsingle.egtsingledisplay.egtsingledisplay
 */
import angular from 'angular';
import Egtinfo from 'mapbs/components/reportpanel/egtsingle/data/egtinfo.js'; // eslint-disable-line no-unused-vars
import Eigentumsauskunft from 'mapbs/components/reportpanel/egtsingle/data/eigentumsauskunft.js';

import '../egtsingle.scss';

const moduleEgtsingledisplay = angular.module('mapbsEgtsingleDisplayModule', []);

moduleEgtsingledisplay.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put(
            'mapbs/egtsingledisplay',
            require('./egtsingledisplay.html')
        );
    }
);

/**
 * @type {!angular.Component}
 */
const EgtsingleDisplay = {
    controller: 'mapbsEgtsingleDisplayController as ctrl',
    templateUrl: () => 'mapbs/egtsingledisplay',
    bindings: {
        'egtinfo': '<mapbsEgtsingleDisplayEgtinfo',
        'showcaptcha': '<mapbsEgtsingleDisplayShowcaptcha',
        'callback': '&mapbsSelectegt',
    },
};

moduleEgtsingledisplay.component('mapbsEgtsingleDisplay', EgtsingleDisplay);

class EgtsingleDisplayController {
    /**
   * @constructor
   * @private
   * @param {angular.Scope} $scope
   * @param {angular.$http} $http
   * @param {angular.$injector} $injector
   * @ngInject
   */
    constructor($scope, $http, $injector) {
        this.scope = $scope;
        this.http = $http;

        this.baseurl = $injector.get('ngeoEgtBase');

        /** @type {string}  */
        this.componentstate = 'wait';

        /** @type {boolean}  */
        this.showcaptcha;

        /** @type {string} */
        this.recaptchaSiteKey = '6LdjRScUAAAAAL2XDfIvfms6Kym1YWzKdz6aVNsT';

        /** @type {string}  */
        this.captchasolution = '';

        /** @type {Egtinfo}  */
        this.egtinfo;

        /**
     * @type {Eigentumsauskunft}
     */
        this.eigentumsauskunft;

        /** @type {boolean}  */
        this.isDownloading = false;

        this.scope.$watch(
            () => {
                return this.egtinfo;
            },
            () => {
                this.initEgtInfo();
            }
        );
    }

    /**
   * sets state of display
   * @param {string} state
   * @private
   */
    setState(state) {
        this.componentstate = state;
    }

    /**
   * Call the function selectegt of egtsinglemodal
   * @param {} lgt
   * @private
   */
    mapbsSelectegt(lgt) {
        this.callback({lgt});
    }

    /**
   * prepares step 1 (information) for displaying the infos
   * @private
   */
    initEgtInfo() {
        if (this.showcaptcha) {
            this.renderCaptcha();
        }

        this.setState('egtinfo');
    }

    /**
   * gets the eigentumsauskunft (step from info to show)
   *
   */
    geteigentumauskunft() {
        this.setState('wait');

        this.http
      .get(
          `${
              this.baseurl
          }eigentumsauskunftngeo/api/sektion=${this.egtinfo.sektion}&parznr=${this.egtinfo.parzellennummer}&passkey=${
              this.captchasolution
          }`,
          {withCredentials: true}
      )
      .then((response) => {
          this.handleEgtAuskunftResponse(response.data);
      })
      .catch((ex) => {
          const egti = new Egtinfo();
          egti.sektion = this.sektion;
          egti.parzellennummer = this.parznr;
          if (ex.status === 403) {
              egti.egtinfotext = 'Die Eigentumsauskunft ist in Ihrem Land nicht verfügbar.';
          } else {
              egti.egtinfotext = 'Die Eigentumsauskunft ist momentan nicht verfügbar.';
          }
          this.egtinfo = egti;
      });
    }

    /**
   *
   * @param {Object} data
   * @private
   */
    handleEgtAuskunftResponse(data) {
        const egta = new Eigentumsauskunft();

        egta.isinmutation =
      data['grundstueck']['parzellenindex'] > data['indexav']['nummerindex'];
        egta.grundstueck = /** @type {Array} */ (data['grundstueck']);
        egta.adressen = /** @type {Array} */ (data['adressen']);
        egta.grundstuecke = /** @type {Array} */ (data['grundstuecke']);
        egta.pdfuuid = /** @type {?String} */ (data['pdfuuid']);
        egta.indexav = /** @type {Object} */ (data['indexav']);
        egta.eigentuemer = /** @type {Array} */ (data['eigentum']);

        let i;
        for (i = 0; i < egta.grundstuecke.length; i++) {
            if (egta.grundstuecke[i]['grundstueckartid'] === 3) {
                egta.stockwerkeigentum = 1;
            }
        }

        for (i = 0; i < egta.eigentuemer.length; i++) {
            if (
                egta.eigentuemer[i]['zusatz'] === 'ja' &&
        egta.eigentuemer[i]['grundstueck'] === false
            ) {
                egta.subjdingl = 1;
            } else if (
                egta.eigentuemer[i]['zusatz'] === 'ja' &&
        egta.eigentuemer[i]['grundstueck'] === true
            ) {
                egta.grundstuecksubjdingl = 1;
            } else {
                egta.eigentumnormal = 1;
            }
            //prepare eigenuemer_text
            egta.eigentuemer[i]['eigentuemer_txt'] = egta.eigentuemer[i]['eigentuemer'];
            if (egta.eigentuemer[i]['pers_adresse'] !== null){
                egta.eigentuemer[i]['eigentuemer_txt'] = egta.eigentuemer[i]['eigentuemer_txt'].concat(', ',egta.eigentuemer[i]['pers_adresse']);
            }
            if (egta.eigentuemer[i]['pers_plz'] !== null){
                egta.eigentuemer[i]['eigentuemer_txt'] = egta.eigentuemer[i]['eigentuemer_txt'].concat(', ',egta.eigentuemer[i]['pers_plz']);
            }
            if (egta.eigentuemer[i]['pers_ort'] !== null){
                egta.eigentuemer[i]['eigentuemer_txt'] = egta.eigentuemer[i]['eigentuemer_txt'].concat(' ',egta.eigentuemer[i]['pers_ort']);
            }
        }
        this.eigentumsauskunft = egta;
        this.setState('egtshow');
    }

    /**
   * renders the reCaptcha if necessary
   * @private
   */
    renderCaptcha() {
        setTimeout(() => {
            grecaptcha.render('captcha-container', {
                /** @type {string}  */
                sitekey: this.recaptchaSiteKey,
                callback: (captcha) => {
                    this.resolveCaptcha(captcha);
                },
            });
        }, 150);
    }

    /**
   * @param {string} captchasolution the result of the captcha solution
   * @private
   *
   */
    resolveCaptcha(captchasolution) {
        this.scope.$apply(() => {
            this.captchasolution = captchasolution;
            setTimeout(() => {
                this.scope.$apply(() => {
                    this.showcaptcha = false;
                });
            }, 100);
        });
    }

    /**
   * redirects to the url of the "to be generated" pdf
   *
   */
    startDownload() {
        this.isDownloading = true;
        setTimeout(() => {
            this.scope.$apply(() => {
                this.isDownloading = false;
            });
        }, 5000);
        window.location = this.eigentumsauskunft.pdfuuid;
    }
}

moduleEgtsingledisplay.controller(
    'mapbsEgtsingleDisplayController',
    EgtsingleDisplayController
);

export default moduleEgtsingledisplay;
